import React, { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import * as CONSTANTS from "../../CONSTANTS";

const AuthReset = () => {
  const [process, setProcess]               = useState(false);
  const [step, setStep]                     = useState(1);
  const [emailAddress, setEmailAddress]     = useState("");
  const [formData, setFormData]             = useState({
    code: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleEmailSubmit = async (e) => {
    e.preventDefault();

    if (!emailAddress || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress)) {
      toast.warning("Enter a valid email address");
      return;
    }

    try {
      console.log(emailAddress);
      setProcess(true);
      const res = await axios.post(CONSTANTS.API_URL + "auth/request-reset", { emailAddress });

      console.log(res);
      
      toast.success("Reset code sent to your email");
      setStep(2);
      setProcess(false);
    } catch (err) {
      console.log(err);
      setProcess(false);
      toast.error(err.response?.data?.message || "Failed to send reset email");
    }
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();

    const { code, newPassword, confirmPassword } = formData;

    if (!code || !newPassword || !confirmPassword) {
      toast.warning("Please fill in all fields");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.warning("Passwords do not match");
      return;
    }

    try {
      await axios.put(CONSTANTS.API_URL + "auth/pasword/reset/email/v1/complete", {
        newCode: code,
        emailAddress,
        password: newPassword,
      });

      toast.success("Password reset successful. You can now log in.");
      setStep(1);
      setFormData({ code: "", newPassword: "", confirmPassword: "" });
      setEmailAddress("");
    } catch (err) {
      toast.error(err.response?.data?.message || "Reset failed");
    }
  };

  return (
    <div>
      {step === 1 ? (
        <form onSubmit={handleEmailSubmit}>
          <div className="mb-3">
            <label>Email Address</label>
            <input
              type="email"
              className="form-control"
              value={emailAddress}
              onChange={(e) => setEmailAddress(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-warning w-100" disabled={process}>
            Request Reset Code
          </button>
        </form>
      ) : (
        <form onSubmit={handleResetSubmit}>
          <div className="mb-3">
            <label>Email Code</label>
            <input
              type="text"
              className="form-control"
              name="code"
              value={formData.code}
              onChange={(e) => setFormData({ ...formData, code: e.target.value })}
              required
            />
          </div>

          <div className="mb-3">
            <label>New Password</label>
            <input
              type="password"
              className="form-control"
              name="newPassword"
              value={formData.newPassword}
              onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })}
              required
            />
          </div>

          <div className="mb-3">
            <label>Confirm Password</label>
            <input
              type="password"
              className="form-control"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
              required
            />
          </div>

          <button type="submit" className="btn btn-main w-100">
            Reset Password
          </button>
        </form>
      )}
    </div>
  );
};

export default AuthReset;
